import _ from 'lodash';

import type { EditorAPI } from '#packages/editorAPI';
import { panels } from '#packages/stateManagement';
import { biLogger } from '#packages/util';
import { panelOpened } from '@wix/bi-logger-editor-data/v2';
import { PANELS_MAP } from './constants';

const openPanel = ({
  editorAPI,
  panelId,
  origin,
}: {
  editorAPI: EditorAPI;
  panelId: string;
  origin: string;
}) => {
  const dispatch = editorAPI.store.dispatch;

  if (!(panelId in PANELS_MAP)) {
    throw new Error(`Route with ID: ${panelId} doesn't exist`);
  }

  const { panel, route, payload } = PANELS_MAP[panelId];

  const panelOptions = {
    selectedView: route,
    origin,
    payload,
  };

  if (panels.selectors.isPanelOpenedByName(editorAPI.store.getState(), panel)) {
    dispatch(
      panels.actions.updatePanel(panel, {
        ...panelOptions,
        key: panel + _.uniqueId(),
      }),
    );

    biLogger.report(
      panelOpened({
        panel_name: panel,
        origin,
        details: JSON.stringify(panelOptions),
      }),
    );
  } else {
    dispatch(panels.actions.openLeftPanel(panel, panelOptions, true));
  }
};

export { openPanel };
